import React, {useEffect} from 'react'
import {useNavigate} from "react-router-dom"
import authHeader from './services/auth-header';
import apiRequest from 'services/axois';
import Cookies from "js-cookie";


function Protected(props) {
  const Component = props.component;
  const permission = props.permission;
  const type = props.type;
  const navigate = useNavigate()
  const cookieTimeOut = 0.5; // half day
  const cookieOptions = {
    expires: cookieTimeOut,
    //sameSite: "None",
    //secure: true,
     sameSite: "Lax",
     secure: false,
  };


  // console.log('props: ',props)
  useEffect(() => {
    protectRoute()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])

  async function protectRoute() {//auth/test-token
    await apiRequest('post', "/auth/test-token",{token: localStorage.getItem("user"),userId: localStorage.getItem("userId")}, { headers: authHeader() }).then((result) => {
      // console.log('type? ',type ,result.data.type)
      Cookies.set("privileges", JSON.stringify(result?.data?.privileges), cookieOptions);
      Cookies.set("userType", result.data.type, cookieOptions);
      if(type){
        if(Array.isArray(type)){
          if(!type.includes(result.data.type)){
            navigate("/login")
          }
        } else if(type !== result.data.type) {
          navigate("/login")
        }
      } else {

      const highLevelRoles = [
  "CFO",
  "super admin",
  "Super_Admin",
  "CEO",
  "COO",
  "TrainingManager",
  "manager",
  "Manager",
  "HeadOfIT",
  "DevTeam",
  "Amanah",
  "Teller",
  "branch admin",
  "BRANCH_Admin",
  "branchaccountant",
];

      
        // 'Amanah','Teller','Instructor','super admin','manager','student','corporate','branch admin'
        if(!highLevelRoles.includes(result.data.type)){
            throw new Error('not allowed to view Admin')
        }

        // localStorage.setItem("type", result.data.type);
        // localStorage.setItem("privileges", JSON.stringify(result.data.privileges));
        // console.log('result.data.privileges?? : ',result.data.privileges)
        let isAllowed = false;
        // console.log('perm & path : ',permission,path)
        if(!permission){
          // console.log('perm not def : ',path)
          return
        }

        // localStorage.setItem("privileges", JSON.stringify(result?.data?.privileges));
        for(let route of result?.data?.privileges){
          // console.log('route.path: ',route.path, path)
          // console.log('route.permission: ',permission)
          for(let perm of permission){
            if((perm === 'read_'+route.id && route.read) || (perm === 'create_'+route.id && route.create) || (perm === 'edit_'+route.id && route.edit)){
              // if (sup.permissions && (sup.permissions.includes('read_' + pr.id) && pr.read === 1) || (sup.permissions.includes('create_' + pr.id) && pr.create === 1)) {
              isAllowed = true;
              break;
            }
          }
          if(isAllowed){
            break;
          }
          // if(route.path === path){
          //   isAllowed = true;
          //   break;
          // }
        }
        if(!isAllowed){
          console.log('not allowed????')
          navigate("/admin/dashboard")
        }
      }
    }).catch((err) => {
        console.log('resss err: ',err)
        localStorage.removeItem("user");
        localStorage.removeItem("userId");
        localStorage.removeItem("privileges");
        localStorage.removeItem("type");
        navigate("/login");
        console.log('2!type ',type)

    })
  }

  return (
    <div>
        <Component />
    </div>
  )
}

export default Protected
